// src/components/ClientLayoutMobile.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/api';

const COLOR_SIERRA_GREEN = '#2E5B2E'; 
const COLOR_CANTERA_PINK = '#C19A6B';
const COLOR_SOFT_CREAM = '#F9F9F5';
const COLOR_CHARCOAL = '#333333';
const COLOR_WHITE = '#FFFFFF';

const CONTAINER_STYLE = { 
    minHeight: '100vh', 
    background: COLOR_SIERRA_GREEN,
    color: COLOR_WHITE, 
    padding: '10px 0', // Menos padding en móvil
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center' 
};

function ClientLayoutMobile({ title, children }) {
    const [profile, setProfile] = useState(null);
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login', { replace: true });
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            handleLogout();
            return;
        }

        const config = { headers: { Authorization: `Bearer ${token}` } };
        api.get('/profile/me', config)
            .then(res => setProfile(res.data))
            .catch(err => {
                console.error('Error cargando perfil', err);
            });
    }, [navigate]);

    const username = profile ? (profile.firstName && profile.lastName ? `${profile.firstName} ${profile.lastName}` : profile.username) : 'Cliente';
    const displayTitle = title || `Bienvenido, ${username}`; 

    return (
        <div style={CONTAINER_STYLE}>
            {/* HEADER APILADO PARA MÓVIL */}
            <div style={{ width: '100%', padding: '0 15px', display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'center', marginBottom: 20 }}>
                
                <h1 style={{ color: COLOR_CANTERA_PINK, margin: 0, fontSize: 20, textAlign: 'center' }}>{displayTitle}</h1>
                
                <div style={{ display: 'flex', gap: 10, alignItems: 'center', justifyContent: 'center' }}> 
                    
                    {title && displayTitle.indexOf('Bienvenido') === -1 && (
                         <button 
                            onClick={() => navigate('/bienvenida')} 
                            style={{ background: COLOR_CANTERA_PINK, color: COLOR_WHITE, padding: '8px 12px', borderRadius: 8, border: 'none', cursor: 'pointer', fontWeight: '600', fontSize: 14 }}
                        >
                            Dashboard
                        </button>
                    )}

                    <Link to="/contacto" style={{ background: COLOR_CANTERA_PINK, color: COLOR_WHITE, padding: '6px 10px', borderRadius: 6, border: 'none', cursor: 'pointer', fontWeight: '600', textDecoration: 'none', fontSize: 12 }}>Soporte</Link>
                    
                    <button onClick={handleLogout} style={{ background: '#DC2626', color: COLOR_WHITE, padding: '8px 12px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 14 }}>Salir</button>
                </div>
            </div>

            {/* Contenido específico de la página */}
            {children}
            
        </div>
    );
}

export default ClientLayoutMobile;